
import AlertCircle from 'vue-material-design-icons/AlertCircle.vue'
import HandBackLeft from 'vue-material-design-icons/HandBackLeft.vue'
import Microphone from 'vue-material-design-icons/Microphone.vue'
import MicrophoneOff from 'vue-material-design-icons/MicrophoneOff.vue'
import Monitor from 'vue-material-design-icons/Monitor.vue'
import VideoIcon from 'vue-material-design-icons/Video.vue'
import VideoOff from 'vue-material-design-icons/VideoOff.vue'

import { emit } from '@nextcloud/event-bus'

import NcButton from '@nextcloud/vue/dist/Components/NcButton.js'
import Tooltip from '@nextcloud/vue/dist/Directives/Tooltip.js'

import TransitionWrapper from '../../UIShared/TransitionWrapper.vue'

import { PARTICIPANT } from '../../../constants.js'
import { ConnectionState } from '../../../utils/webrtc/models/CallParticipantModel.js'

export default {
	name: 'VideoBottomBar',

	components: {
		AlertCircle,
		HandBackLeft,
		Microphone,
		MicrophoneOff,
		Monitor,
		NcButton,
		TransitionWrapper,
		VideoIcon,
		VideoOff,
	},

	directives: {
		tooltip: Tooltip,
	},

	inheritAttrs: false,

	props: {
		token: {
			type: String,
			required: true,
		},
		isSidebar: {
			type: Boolean,
			default: false,
		},
		hasShadow: {
			type: Boolean,
			default: false,
		},
		isBig: {
			type: Boolean,
			default: false,
		},
		participantName: {
			type: String,
			default: '',
		},
		showVideoOverlay: {
			type: Boolean,
			default: true,
		},
		model: {
			type: Object,
			required: true,
		},
		sharedData: {
			type: Object,
			required: true,
		},
		// True if the bottom bar is used in the screen component
		isScreen: {
			type: Boolean,
			default: false,
		},
		// The current promoted participant
		isPromoted: {
			type: Boolean,
			default: false,
		},
		// Is the current selected participant
		isSelected: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		connectionStateFailedNoRestart() {
			return this.model.attributes.connectionState === ConnectionState.FAILED_NO_RESTART
		},

		// Common indicators
		showRaiseHandIndicator() {
			return !this.connectionStateFailedNoRestart && this.model.attributes.raisedHand.state
		},
		showStopFollowingButton() {
			return this.isBig && this.$store.getters.selectedVideoPeerId !== null
		},

		// Audio indicator
		showAudioIndicator() {
			return !this.connectionStateFailedNoRestart && !this.isAudioButtonHidden
		},
		isAudioButtonHidden() {
			return this.model.attributes.audioAvailable && !this.canFullModerate
		},
		isAudioButtonDisabled() {
			return !this.model.attributes.audioAvailable || !this.canFullModerate
		},
		audioButtonTooltip() {
			return this.model.attributes.audioAvailable
				? t('spreed', 'Mute')
				: t('spreed', 'Muted')
		},

		// Video indicator
		showVideoIndicator() {
			return !this.connectionStateFailedNoRestart && this.model.attributes.videoAvailable
		},
		isRemoteVideoEnabled() {
			return this.sharedData.remoteVideoBlocker?.isVideoEnabled()
		},
		isRemoteVideoBlocked() {
			return this.sharedData.remoteVideoBlocker && !this.sharedData.remoteVideoBlocker.isVideoEnabled()
		},
		videoButtonTooltip() {
			return this.isRemoteVideoEnabled
				? t('spreed', 'Disable video')
				: t('spreed', 'Enable video')
		},

		// ScreenSharing indicator
		showScreenSharingIndicator() {
			return !this.connectionStateFailedNoRestart && this.model.attributes.screen
		},

		// Name indicator
		isCurrentlyActive() {
			return this.isSelected || this.model.attributes.speaking
		},
		showParticipantName() {
			return !this.model.attributes.videoAvailable || this.isRemoteVideoBlocked
				|| this.showVideoOverlay || this.isPromoted || this.isCurrentlyActive
		},

		// Moderator rights
		participantType() {
			return this.$store.getters.conversation(this.token)?.participantType
				|| (this.$store.getters.getUserId() !== null
					? PARTICIPANT.TYPE.USER
					: PARTICIPANT.TYPE.GUEST)
		},
		canFullModerate() {
			return this.participantType === PARTICIPANT.TYPE.OWNER || this.participantType === PARTICIPANT.TYPE.MODERATOR
		},
	},

	methods: {
		forceMute() {
			this.model.forceMute()
		},

		toggleVideo() {
			this.sharedData.remoteVideoBlocker.setVideoEnabled(!this.isRemoteVideoEnabled)
		},

		switchToScreen() {
			if (!this.sharedData.screenVisible || !this.isBig) {
				emit('switch-screen-to-id', this.model.attributes.peerId)
			}
		},

		handleStopFollowing() {
			this.$store.dispatch('stopPresentation')
			this.$store.dispatch('selectedVideoPeerId', null)
		},
	},
}
